import { render, staticRenderFns } from "./TerminalRequestFormCrossSelling.vue?vue&type=template&id=4c54a9ce&scoped=true&"
import script from "./TerminalRequestFormCrossSelling.vue?vue&type=script&lang=js&"
export * from "./TerminalRequestFormCrossSelling.vue?vue&type=script&lang=js&"
import style0 from "./TerminalRequestFormCrossSelling.vue?vue&type=style&index=0&id=4c54a9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54a9ce",
  null
  
)

export default component.exports